<template>
  <Destination />
</template>

<script setup lang="ts">
import Destination from '@/wabunka-src/features/Destination/pages/Destination/Destination.vue';
// 境界線なし・白文字のヘッダー
definePageMeta({ layout: 'en-experience-id', headerBgTransparent: true });
</script>
